import React from 'react';
import style from './MealPlan.module.css';
import { getMealEntriesForDay } from '../../utils/mealPlan';

const mealIcons = {
	Breakfast: 'sunrise',
	Lunch: 'midday',
	Dinner: 'evening',
};

const MealPlan = ({ dayNumber, dayName, meals }) => {
	const mealEntries = getMealEntriesForDay(meals);

	return (
		<div className={style.MealCard}>
			<div className={style.CardHeader}>
				<span className={style.DayNumber}>{dayNumber}</span>
				<span className={style.DayName}>{dayName}</span>
			</div>

			<div className={style.MealsList}>
				{mealEntries.map(({ mealType, name, calories }) => (
					<div key={mealType} className={style.MealRow}>
						<div className={style.MealLabel}>
							<span className={`${style.MealDot} ${style[mealIcons[mealType]] || ''}`} />
							<span className={style.MealType}>{mealType}</span>
						</div>
						<span className={style.MealName}>{name}</span>
						{calories !== null && (
							<span className={style.MealCalories}>{calories} cal</span>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default MealPlan;
